import { useCallback, useState } from 'react';
import {
  type Institution,
  useLazyGetInstitutionByDomainQuery,
} from '../../../services';

type GetInstitutionByDomainProps = {
  institutionDomain: string;
};

export type UseInstitutionReturnType = {
  isPending: boolean;
  institution: Institution | undefined;
  error: unknown;
  getInstitutionByDomain: (props: GetInstitutionByDomainProps) => Promise<void>;
};

export const useInstitution = (): UseInstitutionReturnType => {
  const [isPending, setIsPending] = useState(false);

  const [getInstitutionByDomainQuery, { data: institution, error }] =
    useLazyGetInstitutionByDomainQuery();

  const getInstitutionByDomain = useCallback(
    async ({
      institutionDomain,
    }: GetInstitutionByDomainProps): Promise<void> => {
      setIsPending(true);
      await getInstitutionByDomainQuery({ institutionDomain });
      setIsPending(false);
    },
    [getInstitutionByDomainQuery],
  );

  return {
    isPending,
    institution,
    error,
    getInstitutionByDomain,
  };
};
